import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CANNED_MESSAGES_FEATURE_KEY,
  State,
  CannedMessagesPartialState,
  CannedMessagesAdapter
} from './canned-messages.reducer';

export const selectState = createFeatureSelector<
  CannedMessagesPartialState,
  State
>(CANNED_MESSAGES_FEATURE_KEY);

const { selectAll, selectIds, selectEntities } =
  CannedMessagesAdapter.getSelectors();

export const getAllCannedMessages = createSelector(selectState, selectAll);
export const getAllCannedMessagesIds = createSelector(selectState, selectIds);
export const getCannedMessagesEntities = createSelector(
  selectState,
  selectEntities
);

export const getSelectedCannedMessageId = createSelector(
  selectState,
  (state: State) => state.selectedId
);

export const getSelectedCannedMessage = createSelector(
  getCannedMessagesEntities,
  getSelectedCannedMessageId,
  (entities, selectedId) => {
    return selectedId ? entities[selectedId] : null;
  }
);
